'use strict';

/*global app*/
/*global services*/

function ProductionTimingService() {
  this.modal = null;

  this.init();
}

ProductionTimingService.prototype = $.extend({}, {
  constructor: 'ProductionTimingService',

  //----------------------------------------------------------------------------

  start: function start(jcOperationRID, callback) {
    var _this = this;

    var timeStart = (new Date()).getTime();
    app.post(app.path('production_timing_start'), { JCOperationRID: jcOperationRID, TimeStart: timeStart }, function (res) {
      if (res.msg === 'SUCCESS') {
        if (callback) {
          callback(timeStart);
        }
      } else {
        app.viewErrorMessage(res);
      }
    });

    return _this;
  },

  //----------------------------------------------------------------------------

  init: function init() {
    var _this = this;

    _this.modal = services.get('modal');

    return _this;
  }
});
